import Header from "components/Header/Header";
import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <>
    <Header />
    <div style={{
      minHeight: "90vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      background: "#fff",
      padding: "24px",
      boxSizing: "border-box"
    }}>
      <div style={{
        textAlign: "center",
        maxWidth: 720,
        width: "100%",
        borderRadius: 12,
        padding: "48px 32px",
        background: "#220240",
        color: "white",
        boxShadow: "0 6px 20px rgba(34,2,64,0.18)"
      }}>
        <h1 style={{ fontSize: 96, margin: 0, lineHeight: 1 }}>404</h1>
        <p style={{ marginTop: 12, marginBottom: 24, color: "#e6e6e6", fontSize: 18 }}>
          Oops — page not found.
        </p>

        <p style={{ margin: 0, color: "#cfcfcf" }}>
          The page you're looking for might have been moved or doesn't exist.
        </p>

        <Link to="/" style={{
          display: "inline-block",
          marginTop: 28,
          padding: "12px 20px",
          background: "white",
          color: "#220240",
          borderRadius: 8,
          textDecoration: "none",
          fontWeight: 600,
          boxShadow: "0 4px 12px rgba(34,2,64,0.12)"
        }}>
          Go back home
        </Link>
      </div>
    </div>
    </>
  );
};

export default NotFound;
